/** The second step of a sign-in, as the service answered it */
export interface Step {
	ticket: string;
	methods: string[];
	expires: string;
}

/**
 * Keeps the second-factor step of a sign-in for the page that finishes it (`/signin/factor`), for the
 * length of this tab and nothing longer. The ticket is single-use and short-lived; it is removed the
 * moment it is taken.
 */
export class Second {
	static KEY = 'beyond.accounts.factor';

	static keep(step: Step, storage: Pick<Storage, 'setItem'> | undefined = globalThis.sessionStorage): void {
		try {
			storage?.setItem(Second.KEY, JSON.stringify(step));
		} catch {
			// Without storage the step cannot travel; the factor page then asks to start again
		}
	}

	/** The kept step, while it has not expired */
	static read(storage: Pick<Storage, 'getItem'> | undefined = globalThis.sessionStorage): Step | undefined {
		try {
			const step = JSON.parse(storage?.getItem(Second.KEY) ?? 'null') as Step | null;
			if (!step?.ticket || Date.parse(step.expires) <= Date.now()) return undefined;
			return step;
		} catch {
			return undefined;
		}
	}

	static forget(storage: Pick<Storage, 'removeItem'> | undefined = globalThis.sessionStorage): void {
		try {
			storage?.removeItem(Second.KEY);
		} catch {
			// Nothing kept
		}
	}
}
